import { Component } from '@angular/core';


@Component({
  selector: 'app-welcome-box',
  templateUrl: './welcome-box.component.html',
  styleUrl: './welcome-box.component.scss'
})
export class WelcomeBoxComponent {

}
